module.exports = __webpack_public_path__ + "static/img/page0-intro.7102ca4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/page0-intro.png
// module id = wU1p
// module chunks = 1